// extracted by mini-css-extract-plugin
export default {"stream-control":"StreamControl_stream-control__GJ7dp","stream-control-button":"StreamControl_stream-control-button__nMxIE"};